import React from "react";
import { AuthConsumer } from "./AuthProvider";
import { LoadingModal } from "../modals"

const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <LoadingModal isBusy={true} loadingText="Loading..." />;
        }}
    </AuthConsumer>
);

export default Logout;